import { Box, styled } from "@mui/material";

export const StyledCratemenu = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: "5rem",
  alignItems: "center",
  ".crateInfo": {
    width: "50rem",
    position: "relative",
    ".tableWrapper": {
      maxHeight: "35rem",
      height: "35rem",
    },
  },
}));
